module.exports = __webpack_public_path__ + "img/file-import.acd6f74b.svg";